module.exports = __webpack_public_path__ + "img/clipboard-list.2c7b290d.svg";